<template>
  <div
    id="dashboard"
    class="row w-100 pl-5 justify-content-start"
    :style="{
      //backgroundImage: `url(${require('@/assets/img/page_bg.png')})`,
      paddingRight: '0px',
      margin: '0px',
      padding: '0px !important',
    }"
  >
    <div class="container-fluid">
      <div>
        <div class="row">
          <div class="h3">預警性封閉進出</div>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-12 bd-callout bg-white">
            <div class="h5 mb-0 font-weight-bold text-primary">
              查詢篩選條件
            </div>
            <div class="row h6">
              <div class="col-12 mt-2">
                <form class="form-inline">
                  <label class="my-1 mr-2" for="inlineFormCustomSelectPref"
                    >選擇風景區</label
                  >
                  <select
                    class="custom-select my-1 mr-sm-2"
                    id="inlineFormCustomSelectPref"
                  >
                    <option value="1">石梯坪</option>
                  </select>
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇起日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-01"
                  />
                  <input
                    type="time"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="08:00"
                  />
                  <label
                    class="my-1 mr-2 text-right"
                    for="inlineFormCustomSelectPref"
                    >選擇訖日</label
                  >
                  <input
                    type="date"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="2022-02-03"
                  />
                  <input
                    type="time"
                    class="form-control my-1 mr-sm-2"
                    id="customControlInline"
                    value="23:59"
                  />
                  <button type="submit" class="btn btn-primary my-1">
                    送出查詢
                  </button>
                  <button type="submit" class="btn btn-primary my-1 ml-2">
                    匯出Excel
                  </button>
                </form>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-12">
                <table :class="tableStyle">
                  <thead :class="tableThStyle">
                    <tr>
                      <th scope="col" width="10%">#</th>
                      <th scope="col" width="15%">風景區</th>
                      <th scope="col" width="15%">日期</th>
                      <th scope="col" width="20%">進入累計</th>
                      <th scope="col" width="40%">離開累計</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(item, key) in dashbords"
                      :key="key"
                      :class="tableCenterStyle"
                    >
                      <td>{{ key + 1 }}</td>
                      <td>石梯坪</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.count }}</td>
                      <td>{{ item.sum }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Home",
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      dashbords: [
        {
          date: "2022/02/01",
          count: "3人",
          sum: "3人",
        },
        {
          date: "2022/02/02",
          count: "1人",
          sum: "4人",
        },
        {
          date: "2022/02/03",
          count: "2人",
          sum: "6人",
        },
      ],
    };
  },
  // components: { DialogModal },
  methods: {
    getTime: function () {
      return moment().subtract("-30", "s").format("YYYY/MM/DD HH:mm");
    },
    selectStreaming: function (item, dashboard) {
      this.$refs.streamingModal.openModal();
      this.selectItem = item;
      this.selectDashoard = dashboard;
    },
  },
};
</script>